import { FileId } from "@inrev/common";
import { type PDFViewerControl } from "@portal/components/patterns/pdf-viewer";
import { useState } from "react";
import { fileViewerControl } from "./fileViewerControl";

export const useFilePreview = (fileId: FileId | undefined) => {
	const [pdfViewerControl, setPdfViewerControl] = useState<PDFViewerControl | undefined>();

	const openFilePreview = () => {
		if (!fileId) return;
		setPdfViewerControl(fileViewerControl(fileId));
	};

	const closeFilePreview = () => setPdfViewerControl(undefined);

	return {
		pdfViewerControl,
		openFilePreview,
		closeFilePreview,
	};
};
